import axiosInstance from "../Utils/axiosInstance";

export const getRbacData = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            `api/general/getRbacReportDetails`
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const getRbacMetaDetails = async () => {
    try {
        const response = await axiosInstance.get(
            `api/general/getRbacMetaDetails`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const getAddedUser = async () => {
    try {
        const response = await axiosInstance.get(
            `api/general/getAddedUserDetials`
        );
        console.log(response);
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const addRbacUser = async (payload: any) => {
    try {
        const response = await axiosInstance.post(
            `api/general/addTheRbacUser`,
            payload
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const updateRbacUser = async (payload: any) => {
    try {
        const response = await axiosInstance.post(
            `api/general/updateTheRbacUser`,
            payload
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const deleteRbacUser = async (ID: string) => {
    try {
        const response = await axiosInstance.post(
            `/api/general/removeTheRbacUser`,
            { rbacID: ID }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const addDepartment = async (deptName: string) => {
    try {
        const response = await axiosInstance.post(
            `/api/general/addTheDepartment`,
            {
                deptName
            }
        );
        return response?.data;
    } catch (error) {
        console.error("Error adding department:", error?.response?.data);
        return error?.response?.data;
    }
};

export const addRole = async (roleName: string) => {
    try {
        const response = await axiosInstance.post(`/api/general/addTheRole`, {
            roleName
        });
        return response?.data;
    } catch (error) {
        console.error("Error adding role:", error?.response?.data);
        return error?.response?.data;
    }
};

export const updateDepartmentStatus = async (
    deptID: string,
    status: string
) => {
    try {
        const response = await axiosInstance.post(
            `/api/general/updateDepartment`,
            {
                deptID,
                status
            }
        );
        return response?.data;
    } catch (error) {
        console.error("Error adding role:", error?.response?.data);
        return error?.response?.data;
    }
};

export const updateRoleStatus = async (roleID: string, status: string) => {
    try {
        const response = await axiosInstance.post(`/api/general/updateRole`, {
            roleID,
            status
        });
        return response?.data;
    } catch (error) {
        console.error("Error adding role:", error?.response?.data);
        return error?.response?.data;
    }
};
